var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F10D4173-DCCE-4261-965B-3902815A87A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart\\xE3o",
    transform: "translate(-703.000000, -165.000000)",
    fill: "#E71037",
    fillRule: "nonzero",
    stroke: "#E71037",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(704.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2929687,1.640625 L16.40625,1.640625 L16.40625,0.65625 C16.40625,0.293835937 16.1124551,0 15.75,0 C15.3875449,0 15.09375,0.293835937 15.09375,0.65625 L15.09375,1.640625 L5.90625,1.640625 L5.90625,0.65625 C5.90625,0.293835937 5.61245508,0 5.25,0 C4.88754492,0 4.59375,0.293835937 4.59375,0.65625 L4.59375,1.640625 L2.70703125,1.640625 C1.21434961,1.640625 0,2.85497461 0,4.34765625 L0,18.2929687 C0,19.7856504 1.21434961,21 2.70703125,21 L18.2929687,21 C19.7856504,21 21,19.7856504 21,18.2929687 L21,4.34765625 C21,2.85497461 19.7856504,1.640625 18.2929687,1.640625 Z M2.70703125,2.953125 L4.59375,2.953125 L4.59375,3.609375 C4.59375,3.97178906 4.88754492,4.265625 5.25,4.265625 C5.61245508,4.265625 5.90625,3.97178906 5.90625,3.609375 L5.90625,2.953125 L15.09375,2.953125 L15.09375,3.609375 C15.09375,3.97178906 15.3875449,4.265625 15.75,4.265625 C16.1124551,4.265625 16.40625,3.97178906 16.40625,3.609375 L16.40625,2.953125 L18.2929688,2.953125 C19.0619297,2.953125 19.6875,3.57869531 19.6875,4.34765625 L19.6875,5.90625 L1.3125,5.90625 L1.3125,4.34765625 C1.3125,3.57869531 1.93807031,2.953125 2.70703125,2.953125 Z M18.2929688,19.6875 L2.70703125,19.6875 C1.93807031,19.6875 1.3125,19.0619297 1.3125,18.2929688 L1.3125,7.21875 L19.6875,7.21875 L19.6875,18.2929688 C19.6875,19.0619297 19.0619297,19.6875 18.2929688,19.6875 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ff962c7b78afece6b3ddb8c83ec81c66.svg";
export { ForwardRef as ReactComponent };